import { render, staticRenderFns } from "./payment-layout.component.vue?vue&type=template&id=00dd8d56"
import script from "./payment-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./payment-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-layout.component.vue?vue&type=style&index=0&id=00dd8d56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports